<template>
  <v-tooltip :disabled="pj.marketReady" bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-btn  text @click="createOrder()" :disabled="!pj.marketReady" >
          <v-icon>
            {{(orderType==='buy')?'mdi-alpha-c-circle': ' mdi-alpha-s-circle' }}
          </v-icon>
        </v-btn>
      </span>
    </template>
    <span>Proyecto abierto a inversiones</span>
  </v-tooltip>
</template>
<script>
export default {
  props:{
    pj:{
      type: Object,
      default: function(){
        return {}
      }
    },
    orderType:{
      type: String,
      default:'buy'
    }
  },
  data(){
    return {
      on:undefined
    }
  },
  methods:{
    createOrder(){
      this.$store.commit('pushModal', 
      {
        type:'NewOrder', 
        params:
        { 
          projectInfo:
          {
            id:this.pj.projectId,
            name:this.pj.projectName,
            currency: this.pj.currency,
            type:this.orderType,
            creditsAvailable: this.pj.credits,
            orderId: this.pj.orderId
          }
        }
      }) 
    },
  }  
}
</script>